<template>
  <div style="width: 100%; height: 100%">
    <div id="pie2"></div>
    <div id="zongzichan">
      <span>总记录</span><b>{{ all }}项</b>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { name } from "file-loader";

export default {
  data() {
    return {
      myData: [
        { value: 12, name: "巡查车" },
        { value: 6, name: "扫地车" },
        { value: 8, name: "小轿车" },
        { value: 14, name: "其他车" },
      ],
      all: 0,
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countApply",
        data: this.searchItem,
      }).then((res) => {
        var mydata = res.data.data;

        var data = [
          {
            value: mydata.waitApproved,
            name: '未审批 ' + mydata.waitApproved
          },
          {
            value: mydata.waitDispatch,
            name: '未派车 ' + mydata.waitDispatch,
          },
          {
            value: mydata.waitStart,
            name: '未出车 ' + mydata.waitStart
          },
          {
            value: mydata.alreadyStart,
            name: '已出车 ' + mydata.alreadyStart
          },
          {
            value: mydata.alreadyFinish,
            name: '已归队 ' + mydata.alreadyFinish
          },
        ];

        this.myData = data;
        this.all = mydata.total;

        this.drawBar("pie2");
      });
    },
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById(id), "dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: ({d}%)",
        },
        legend: {
          // orient: "vertical",
          //图例组件
          left: 0, //图例组件离右边的距离
          orient: "vertical", //布局  纵向布局
          //width: 40, //图行例组件的宽度,默认自适应
          x: "left", //图例显示在右边
          itemWidth: 12, //图例标记的图形宽度
          itemHeight: 12, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: 'pie',
            radius: ["20%", "60%"],
            avoidLabelOverlap: false,
            //roseType: "area",
            label: {
              show: false,
              position: "left",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5d97f7",
          "#06f9aa",
          "#f9c539",
          "#fa3699",
          "#64bff8",
          "#2acc4d",
          "#e860ad",
          "#e8bd60",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  mounted() {
    // this.drawBar("pie2");

  },
};
</script>
<style lang="">
#pie2 {
  width: 100%;
  height: calc(100% - 70px);
}
#zongzichan {
  font-size: 20px;
}
#zongzichan span {
  margin-right: 10px;
  background: #0856a5;
  border-radius: 20px;
  padding: 4px 10px;
  color: #9bdaee;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/abc/pie.vue